// Human-readable labels for section keys used on the dashboard.
// Keys MUST match backend SECTION_KEYS.
export const SECTION_LABELS_DE = {
  marioIntro: '00a · 🎬 Intro-Video Mario Steinrigl',
  thomasIntro: '00b · 🎬 Intro-Video Thomas Kutak',
  introsAudio: '🔊 Intro-Videos mit Ton (aus = stumm)',
  moeglichkeiten: '01 · Deine Möglichkeiten',
  chance: '02 · Die Chance',
  wertentwicklung: '03 · Wertentwicklung Diamant',
  hauptgruende: '04 · Hauptgründe für Diamanten',
  markt: '05 · Diamantenmarkt',
  innovation: '06 · Innovation aus Dubai',
  globalNetwork: '07 · Globales Netzwerk',
  sicherheit: '08 · Sicherheit',
  boxVideo: '08b · 🎬 Black-Box-Video',
  zertifiziert: '09 · Zertifizierung (GIA)',
  zertifiziertVideo: '09b · 🎬 Vlog Zertifizierung',
  kimberley: '10 · Kimberley-Prozess',
  plaene: '11 · Deine Pläne',
  vip: '12 · VIP Möglichkeiten',
  plaeneVIP: '13 · VIP-Pläne',
  ersparnisse: '14 · Deine Ersparnisse',
  moeglichkeitenNach: '15 · Möglichkeiten nach dem Erwerb',
  wieMoeglich: '16 · Wie ist das möglich?',
  traditionellerWeg: '17 · Traditioneller Weg',
  stigWeg: '18 · Der STIG ROCK Weg',
  schliffVlog: '18b · 🎬 Vlog Schliff',
  dualTimeline: '18c · Dual-Timeline (Visualisierung)',
  explainer: '18d · 🎬 Explainer-Video Dual-System',
  einfacherWeg: '19 · Der einfache Weg',
  pause: '19b · 🎬 Pause (Video-Loop)',
  business: '20 · Business (Bonusarten)',
  unilevelBonus: '21 · Unilevel-Bonus',
  infinityBonus: '22 · Infinity-Bonus',
  matchingBonus: '23 · Matching-Bonus',
  worldPools: '24 · World Pools',
  rangBonus: '25 · Rang-Bonus',
  karriere: '26 · Karriere',
  cta: '28 · Kontakt & Abschluss',
  ecosystem: '01 · STIG Ecosystem',
};

export const SECTION_LABELS_EN = {
  marioIntro: '00a · 🎬 Intro video Mario Steinrigl',
  thomasIntro: '00b · 🎬 Intro video Thomas Kutak',
  introsAudio: '🔊 Intro videos with sound (off = muted)',
  moeglichkeiten: '01 · Your Opportunities',
  chance: '02 · The Chance',
  wertentwicklung: '03 · Diamond Value Development',
  hauptgruende: '04 · Main Reasons for Diamonds',
  markt: '05 · Diamond Market',
  innovation: '06 · Innovation from Dubai',
  globalNetwork: '07 · Global Network',
  sicherheit: '08 · Security',
  boxVideo: '08b · 🎬 Black-Box video',
  zertifiziert: '09 · Certification (GIA)',
  zertifiziertVideo: '09b · 🎬 Certification vlog',
  kimberley: '10 · Kimberley Process',
  plaene: '11 · Your Plans',
  vip: '12 · VIP Opportunities',
  plaeneVIP: '13 · VIP Plans',
  ersparnisse: '14 · Your Savings',
  moeglichkeitenNach: '15 · Post-Purchase Options',
  wieMoeglich: '16 · How Is That Possible?',
  traditionellerWeg: '17 · Traditional Path',
  stigWeg: '18 · The STIG ROCK Way',
  schliffVlog: '18b · 🎬 Cutting vlog',
  dualTimeline: '18c · Dual timeline (visualization)',
  explainer: '18d · 🎬 Explainer video dual system',
  einfacherWeg: '19 · The Simple Path',
  pause: '19b · 🎬 Pause (video loop)',
  business: '20 · Business (Bonus Types)',
  unilevelBonus: '21 · Unilevel Bonus',
  infinityBonus: '22 · Infinity Bonus',
  matchingBonus: '23 · Matching Bonus',
  worldPools: '24 · World Pools',
  rangBonus: '25 · Rank Bonus',
  karriere: '26 · Career',
  cta: '28 · Contact & Close',
  ecosystem: '01 · STIG Ecosystem',
};

export const SECTION_ORDER = [
  'marioIntro', 'thomasIntro', 'introsAudio',
  'moeglichkeiten', 'chance', 'wertentwicklung', 'hauptgruende', 'markt',
  'innovation', 'globalNetwork', 'sicherheit', 'boxVideo',
  'zertifiziert', 'zertifiziertVideo', 'kimberley',
  'plaene', 'vip', 'plaeneVIP', 'ersparnisse', 'moeglichkeitenNach',
  'wieMoeglich', 'traditionellerWeg', 'stigWeg', 'schliffVlog',
  'dualTimeline', 'explainer', 'einfacherWeg',
  'pause',
  'business', 'unilevelBonus', 'infinityBonus', 'matchingBonus',
  'worldPools', 'rangBonus', 'karriere', 'cta', 'ecosystem',
];
